import {createContext, ReactNode, useContext, useState} from "react";

import {MonitoringServer} from "@/lib/types/monitoring";
import {TestResult} from "@/pages/checks/components/form/fields/legacy/testRunnerTypes";

interface TestRunnerSharedState {
  testResult: TestResult | null;
  setTestResult: (r: TestResult | null) => void;
  affectedFields: string[];
  setAffectedFields: (v: string[]) => void;
  selectedLocation: MonitoringServer | null;
  setSelectedLocation: (location: MonitoringServer | null) => void;
}

const useTestRunnerSharedState = (): TestRunnerSharedState => {
  const [testResult, setTestResult] = useState<TestResult | null>(null);
  const [affectedFields, setAffectedFields] = useState<string[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<MonitoringServer | null>(null);

  return {
    testResult,
    setTestResult,
    affectedFields,
    setAffectedFields,
    selectedLocation,
    setSelectedLocation,
  };
};

const TestRunnerContext = createContext<TestRunnerSharedState | undefined>(undefined);

export const TestRunnerProvider = ({children}: {children: ReactNode}) => {
  const sharedState = useTestRunnerSharedState();
  return <TestRunnerContext.Provider value={sharedState}>{children}</TestRunnerContext.Provider>;
};

export const useTestRunnerContext = () => {
  return useContext(TestRunnerContext);
};
